[
  {
    "id": "MET-INH-L3-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een zwembad wordt gevuld met 18.000 liter water. Hoeveel kubieke meter ($m^3$) is dat?",
    "options": [
      "1,8 $m^3$",
      "18 $m^3$",
      "180 $m^3$",
      "1.800 $m^3$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-ZWEMBAD",
    "explanation": "1 kubieke meter (m³) = 1000 liter. Dus 18.000 : 1000 = 18 m³.",
    "distractorExplanations": {
      "0": "Je deelde door 10.000. Maar 1 m³ = 1000 liter.",
      "2": "Je deelde door 100. Maar er gaan 1000 liter in een kuub!",
      "3": "Je deelde door 10. Dat is te weinig."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "m3",
        "value": 18000,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L3-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een vrachtwagen mag maximaal 3.500 kilogram laden. Er staan al dozen van samen 2.750 kg in. Hoeveel kilogram mag er nog bij?",
    "options": [
      "750 kg",
      "850 kg",
      "650 kg",
      "1.000 kg"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-VRACHTWAGEN",
    "explanation": "Maximaal 3.500 kg, er staat al 2.750 kg in. Trek af: 3.500 - 2.750 = 750 kg.",
    "distractorExplanations": {
      "1": "Rekenfoutje bij het aftrekken. Check: 3.500 - 2.750 = 750.",
      "2": "Rekenfoutje bij het aftrekken. Check: 3.500 - 2.750 = 750.",
      "3": "Je deed 3.500 - 2.500. Maar er staat al 2.750 kg in, niet 2.500 kg!"
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Maximaal Gewicht",
        "content": "Maximaal gewicht - wat er al in zit = wat er nog bij mag.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L3-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een route is 2,8 kilometer. Hoeveel meter is dat?",
    "options": [
      "280 meter",
      "2.800 meter",
      "28.000 meter",
      "2800 kilometer"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-ROUTE",
    "explanation": "Van km naar m zijn het 3 stappen omlaag. Dus: 2,8 × 1000 = 2.800 meter.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is van km naar hm.",
      "2": "Je deed ×10.000. Dat is één stap te veel.",
      "3": "Je veranderde de eenheid verkeerd. Het antwoord moet in meters."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 2.8,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L3-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een plank is 1,75 meter lang. Hoeveel centimeter is dat?",
    "options": [
      "17,5 cm",
      "175 cm",
      "1.750 cm",
      "0,175 cm"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-PLANK",
    "explanation": "Van meter naar centimeter zijn het 2 stappen omlaag. Dus: 1,75 × 100 = 175 cm.",
    "distractorExplanations": {
      "0": "Je deed ×10 in plaats van ×100.",
      "2": "Je deed ×1000. Dat is één stap te veel.",
      "3": "Je deelde in plaats van keer."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "cm",
        "value": 1.75,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L3-003",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een pad is 4.500 meter lang. Hoeveel kilometer is dat?",
    "options": [
      "0,45 km",
      "4,5 km",
      "45 km",
      "450 km"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-PAD-E6",
    "explanation": "Van meter naar kilometer zijn het 3 stappen omhoog. Dus delen door 1000: 4.500 : 1000 = 4,5 km.",
    "distractorExplanations": {
      "0": "Je deelde door 10.000. Dat is één stap te veel.",
      "2": "Je vergat de komma. 4.500 m is geen 45 km.",
      "3": "Je deed ×1000 in plaats van ÷1000."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "km",
        "value": 4500,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L3-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Hoeveel gram is 2,35 kilogram?",
    "options": [
      "2.350 g",
      "235 g",
      "23.500 g",
      "2.035 g"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-KG-G",
    "explanation": "Van kg naar g zijn het 3 stappen omlaag. Dus: 2,35 × 1000 = 2.350 g.",
    "distractorExplanations": {
      "1": "Je verplaatste de komma één plek in plaats van drie.",
      "2": "Je zette er een nul te veel bij. Het is ×1000.",
      "3": "Je maakte een kommafout."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 2.35,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L3-003",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een fles weegt 1.200 gram. Hoeveel kilogram is dat?",
    "options": [
      "0,12 kg",
      "1,2 kg",
      "12 kg",
      "120 kg"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-FLES",
    "explanation": "Van gram naar kilogram zijn het 3 stappen omhoog. Dus: 1.200 : 1000 = 1,2 kg.",
    "distractorExplanations": {
      "0": "Je deelde door 10.000. Dat is één stap te veel.",
      "2": "Je vergat de komma. 1.200 g is geen 12 kg.",
      "3": "Je deed ×1000 in plaats van ÷1000."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "g",
        "to": "kg",
        "value": 1200,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L3-003",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een fles bevat 0,75 liter limonade. Hoeveel milliliter is dat?",
    "options": [
      "75 ml",
      "750 ml",
      "7.500 ml",
      "0,75 ml"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-LIMONADE-E6",
    "explanation": "Van liter naar milliliter zijn het 3 stappen omlaag. Dus: 0,75 × 1000 = 750 ml.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is van L naar dL.",
      "2": "Je zette er een nul te veel bij. Het is ×1000.",
      "3": "Je deelde in plaats van keer."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 0.75,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L3-004",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een tank bevat 3,2 kubieke meter water. Hoeveel liter is dat?",
    "options": [
      "320 liter",
      "3.200 liter",
      "32.000 liter",
      "320.000 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-TANK",
    "explanation": "1 m³ = 1000 liter. Dus: 3,2 × 1000 = 3.200 liter.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is te weinig. 1 m³ is 1000 liter.",
      "2": "Je zette er een nul te veel bij. 3,2 × 1000 = 3.200.",
      "3": "Je deed ×100.000. Dat is veel te groot."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "m3",
        "to": "l",
        "value": 3.2,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L3-005",
    "module": "Metriek",
    "difficulty": 105,
    "question": "In een vat zit 7.500 milliliter sap. Hoeveel liter is dat?",
    "options": [
      "0,75 liter",
      "7,5 liter",
      "75 liter",
      "750 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-VAT",
    "explanation": "Van ml naar liter zijn het 3 stappen omhoog. Dus: 7.500 : 1000 = 7,5 liter.",
    "distractorExplanations": {
      "0": "Je deelde door 10.000. Dat is één stap te veel.",
      "2": "Je vergat de komma. 7.500 ml is geen 75 liter.",
      "3": "Je deed ×1000 in plaats van ÷1000."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "ml",
        "to": "l",
        "value": 7500,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L3-006",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een bak is 40 cm lang, 25 cm breed en 30 cm hoog. Hoeveel liter past erin?",
    "options": [
      "3 liter",
      "30 liter",
      "300 liter",
      "0,3 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAK",
    "explanation": "Eerst inhoud in cm³: 40 × 25 × 30 = 30.000 cm³. Deel door 1000: 30.000 : 1000 = 30 liter.",
    "distractorExplanations": {
      "0": "Je deelde nog een keer door 10. Maar 30.000 cm³ is 30 liter.",
      "2": "Je vergat te delen door 1000 om liter te krijgen.",
      "3": "Je zette de komma verkeerd. 30.000 cm³ is geen 0,3 liter."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Van cm³ naar liter",
        "content": "Bereken eerst cm³ en deel daarna door 1000: 40 × 25 × 30 = 30.000 cm³ → 30 liter.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L3-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een vloer is 2,5 $m^2$. Hoeveel vierkante centimeter is dat?",
    "options": [
      "2.500 $cm^2$",
      "25.000 $cm^2$",
      "250.000 $cm^2$",
      "25 $cm^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-VLOER",
    "explanation": "1 m² = 10.000 cm². Dus: 2,5 × 10.000 = 25.000 cm².",
    "distractorExplanations": {
      "0": "Je deed ×1000. Maar bij m² ga je ×10.000.",
      "2": "Je deed ×100.000. Dat is één stap te veel.",
      "3": "Je vergat te vermenigvuldigen met 10.000."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Oppervlakte omrekenen",
        "content": "1 m² = 10.000 cm². Vermenigvuldig dus met 10.000.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L3-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een vel papier is 2.400 $cm^2$. Hoeveel vierkante meter is dat?",
    "options": [
      "0,024 $m^2$",
      "0,24 $m^2$",
      "2,4 $m^2$",
      "24 $m^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-PAPIER",
    "explanation": "1 m² = 10.000 cm². Dus: 2.400 : 10.000 = 0,24 m².",
    "distractorExplanations": {
      "0": "Je deelde door 100. Maar bij m² is het delen door 10.000.",
      "2": "Je vergat de komma. 2.400 cm² is geen 2,4 m².",
      "3": "Je deed ×10.000 in plaats van ÷10.000."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "cm² naar m²",
        "content": "Deel door 10.000 om van cm² naar m² te gaan.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L3-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een rechthoek heeft een omtrek van 68 meter. De lengte is 20 meter. Wat is de breedte?",
    "options": [
      "8 meter",
      "14 meter",
      "24 meter",
      "28 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-LENGTE",
    "explanation": "Omtrek = 2 × lengte + 2 × breedte. 2 × 20 = 40. 68 - 40 = 28. Dan 28 : 2 = 14 meter.",
    "distractorExplanations": {
      "0": "Je deelde 68 door 8. Maar eerst moet je de lengtes eraf halen.",
      "2": "Je vergat nog door 2 te delen. 28 is voor beide breedtes samen.",
      "3": "Je deed 68 - 20. Maar je moet twee lengtes aftrekken."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Omtrek terugrekenen",
        "content": "Omtrek = 2L + 2B. Trek eerst 2 × lengte af, deel daarna door 2.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L3-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Een rechthoekig plein is 25 meter lang en 15 meter breed. Je loopt 4 rondjes eromheen. Hoeveel meter loop je?",
    "options": [
      "160 meter",
      "200 meter",
      "320 meter",
      "400 meter"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-PLEIN",
    "explanation": "Eén rondje: 25 + 15 + 25 + 15 = 80 meter. Vier rondjes: 80 × 4 = 320 meter.",
    "distractorExplanations": {
      "0": "Je deed 40 × 4. Maar de omtrek is 80, niet 40.",
      "1": "Je rekende één rondje te veel of te weinig. Het zijn 4 rondjes.",
      "3": "Je deed 100 × 4. Maar de omtrek is 80."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 25,
        "height": 15,
        "mode": "perimeter",
        "label": "Omtrek plein = 80 m"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-E6-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Zet in de juiste volgorde van kort naar lang: 2,5 km — 3.200 m — 280.000 cm",
    "options": ["2,5 km — 2.800 m — 3.200 m", "3.200 m — 2.800 m — 2,5 km", "2.800 m — 2,5 km — 3.200 m", "2,5 km — 3.200 m — 2.800 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-SORT-E6",
    "explanation": "Maak alles meters: 2,5 km = 2.500 m, 3.200 m, 280.000 cm = 2.800 m. Volgorde: 2.500 — 2.800 — 3.200.",
    "distractorExplanations": {
      "1": "Dit is van lang naar kort.",
      "2": "280.000 cm = 2.800 m. Dat is minder dan 3.200 m maar meer dan 2.500 m.",
      "3": "Check de omrekening: 280.000 cm = 2.800 m."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 2.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-E6-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Wat is meer: 0,6 liter of 550 ml?",
    "options": ["0,6 liter", "550 ml", "Even veel", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-L-ML-E6",
    "explanation": "0,6 liter = 600 ml. 600 ml is meer dan 550 ml.",
    "distractorExplanations": {
      "1": "550 ml is 0,55 liter. Dat is minder dan 0,6 liter.",
      "2": "Ze zijn niet even veel.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 0.6,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-E6-003",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Wat is zwaarder: 2,4 kg of 2.350 gram?",
    "options": ["2,4 kg", "2.350 gram", "Even zwaar", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-KG-G-E6",
    "explanation": "2,4 kg = 2.400 gram. 2.400 gram is meer dan 2.350 gram.",
    "distractorExplanations": {
      "1": "2.350 gram is 2,35 kg. Dat is minder dan 2,4 kg.",
      "2": "Ze zijn niet even zwaar. Het verschil is 50 gram.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 2.4,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-SCHAT-E6-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Hoeveel liter benzine past er ongeveer in de tank van een auto?",
    "options": ["50 liter", "5 liter", "500 liter", "5.000 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_schatten",
    "familyId": "MET-SCHAT-TANK-E6",
    "explanation": "In een gewone autotank past ongeveer 50 liter benzine.",
    "distractorExplanations": {
      "1": "Dat is maar een jerrycan. Een autotank is veel groter.",
      "2": "Dat is een heel groot vat. Een autotank is kleiner.",
      "3": "Dat is een tankwagen. Veel te groot voor een auto."
    }
  },
  {
    "id": "MET-SCHAT-E6-002",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Hoeveel weegt een fiets ongeveer?",
    "options": ["15 kilogram", "1,5 kilogram", "150 kilogram", "150 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_schatten",
    "familyId": "MET-SCHAT-FIETS-E6",
    "explanation": "Een gewone fiets weegt ongeveer 15 kilogram.",
    "distractorExplanations": {
      "1": "Dat is zo licht als een pak melk. Een fiets is veel zwaarder!",
      "2": "Dat is zo zwaar als een volwassen persoon. Een fiets is lichter.",
      "3": "Dat is lichter dan een appel. Een fiets is veel zwaarder!"
    }
  },
  {
    "id": "MET-LKOM-E6-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Reken om: 0,45 km = ... meter",
    "options": ["450 m", "45 m", "4.500 m", "4,5 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-LKOM-KM-M-E6",
    "explanation": "1 km = 1.000 m. 0,45 × 1.000 = 450 meter.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000. Dat is te veel.",
      "3": "Je deed ×10. Dat is te weinig."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 0.45,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GKOM-E6-001",
    "module": "Metriek",
    "difficulty": 105,
    "question": "Reken om: 4.750 gram = ... kg",
    "options": ["4,75 kg", "47,5 kg", "0,475 kg", "475 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-GKOM-G-KG-E6",
    "explanation": "1.000 gram = 1 kg. 4.750 : 1.000 = 4,75 kg.",
    "distractorExplanations": {
      "1": "Je deelde door 100 in plaats van 1.000.",
      "2": "Je deelde door 10.000. Dat is te veel.",
      "3": "Je deed ×100 in plaats van ÷1.000."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "g",
        "to": "kg",
        "value": 4750,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  }
]